import { ChevronRight } from 'lucide-react'

export interface Crumb {
  label: string
  /** Omit on the current page. */
  href?: string
}

/**
 * "Home / Approvals". Deliberately a labelled group, not a second `nav` landmark: the main
 * navigation is the one navigation landmark on the page, and screen-reader users (and the
 * browser tests) look for exactly one.
 */
export function Breadcrumb({ crumbs, onNavigate }: { crumbs: Crumb[]; onNavigate: (href: string) => void }) {
  if (crumbs.length < 2) return null
  return (
    <div role="group" aria-label="You are here" className="no-print">
      <ol className="flex min-w-0 flex-wrap items-center gap-1 text-label text-muted">
        {crumbs.map((c, i) => (
          <li key={`${c.label}-${i}`} className="flex min-w-0 items-center gap-1">
            {i > 0 && <ChevronRight size={14} aria-hidden className="shrink-0" />}
            {c.href ? (
              <a
                href={c.href}
                onClick={(e) => {
                  e.preventDefault()
                  onNavigate(c.href!)
                }}
                className="rounded-control px-1 font-medium text-brand hover:underline"
              >
                {c.label}
              </a>
            ) : (
              <span aria-current="page" className="truncate px-1 font-medium text-neutral">
                {c.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </div>
  )
}
